// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plan detail page — RT2 native layout */
.rt-plan-detail {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rt-plan-detail__panel {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 18px;
  color: var(--text-primary);
}

.rt-plan-detail__heading {
  margin: 0 0 12px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
}

.rt-plan-detail__section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.rt-plan-detail__section-head .rt-plan-detail__heading {
  margin: 0;
}

.rt-plan-detail__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px 20px;
  margin: 0;
}

.rt-plan-detail__grid dt {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.rt-plan-detail__grid dd {
  margin: 0;
  font-size: 0.95rem;
  color: var(--text-primary);
  word-break: break-word;
}

.rt-plan-detail__span {
  grid-column: 1 / -1;
}

.rt-plan-detail__danger {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}

/* Metric cards that embed badges */
.rt-plan-detail .rt-metric-card__value {
  display: flex;
  align-items: center;
  min-height: 1.6em;
}

/* Run plan modal */
.rt-run-plan-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
  z-index: 13000;
}

.rt-run-plan-panel {
  width: 100%;
  max-width: 28rem;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--modal-background, var(--surface));
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--modal-shadow, var(--shadow-lg));
}

.rt-run-plan-header {
  flex-shrink: 0;
  padding: 1rem 1.25rem;
  background: linear-gradient(to right, var(--primary), var(--primary-hover));
  color: #fff;
}

.rt-run-plan-header h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #fff;
}

.rt-run-plan-header p {
  margin: 0.25rem 0 0;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
}

.rt-run-plan-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.rt-run-plan-project {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid color-mix(in srgb, var(--primary) 30%, var(--border));
  background: var(--primary-muted);
}

.rt-run-plan-project p {
  margin: 0;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.rt-run-plan-label {
  color: var(--text-secondary);
  font-weight: 500;
}

.rt-run-plan-field label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
}

.rt-required {
  color: var(--danger, #ef4444);
}

.rt-run-plan-hint {
  margin: 0.4rem 0 0;
  font-size: 0.75rem;
  color: var(--primary);
  word-break: break-all;
}

.rt-run-plan-mode {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  margin-top: 0.5rem;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface-raised, var(--surface));
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.rt-run-plan-mode--active {
  border-color: var(--primary);
  background: var(--primary-muted);
}

.rt-run-plan-mode--disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.rt-run-plan-mode__title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.rt-run-plan-mode__desc {
  margin: 0.2rem 0 0;
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.rt-run-plan-soon {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  opacity: 0;
  pointer-events: none;
}

.rt-run-plan-mode--disabled:hover .rt-run-plan-soon {
  opacity: 1;
}

.rt-run-plan-error {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid color-mix(in srgb, var(--danger) 35%, var(--border));
  background: var(--danger-muted);
  color: var(--danger);
  font-size: 0.875rem;
}

.rt-run-plan-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border);
  background: var(--bg-tertiary, var(--surface));
}

[data-theme="light"] .rt-run-plan-footer {
  background: var(--modal-background, #fff);
}

.rt-run-plan-info {
  padding: 0.75rem 1.25rem;
  font-size: 0.75rem;
  color: var(--text-secondary);
  border-top: 1px solid var(--border);
  background: var(--primary-muted);
}

/* Edit plan modal chrome */
.rt-plan-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
}

.rt-plan-modal-panel {
  width: min(640px, 92vw);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--modal-background, var(--surface));
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--modal-shadow, var(--shadow-lg));
}

.rt-plan-modal-panel--sm {
  max-width: 28rem;
  padding: 1.25rem;
  display: block;
}

.rt-plan-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 1rem 1.25rem;
  background: linear-gradient(to right, var(--primary), var(--primary-hover));
  color: #fff;
}

.rt-plan-modal-header h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
}

.rt-plan-modal-close {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0.9;
}

.rt-plan-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 1.25rem;
  background: var(--modal-background, var(--surface));
  color: var(--text-primary);
}

.rt-plan-modal-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border);
  background: var(--bg-tertiary, var(--surface));
}

[data-theme="light"] .rt-plan-modal-footer {
  background: var(--modal-background, #fff);
}

.rt-plan-page-body {
  display: flex;
  flex-direction: column;
  background: transparent;
  color: var(--text-primary);
}

.rt-plan-confirm-title {
  margin: 0 0 0.5rem;
  color: var(--text-primary);
}

.rt-plan-confirm-body {
  margin: 0 0 1.25rem;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.rt-plan-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-plan-detail.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mDAAmD;EACnD,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2EAA2E;EAC3E,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uEAAuE;EACvE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;EACjD,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sEAAsE;EACtE,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mDAAmD;EACnD,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,2EAA2E;EAC3E,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/* Plan detail page — RT2 native layout */\n.rt-plan-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rt-plan-detail__panel {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 16px 18px;\n  color: var(--text-primary);\n}\n\n.rt-plan-detail__heading {\n  margin: 0 0 12px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.rt-plan-detail__section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.rt-plan-detail__section-head .rt-plan-detail__heading {\n  margin: 0;\n}\n\n.rt-plan-detail__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 14px 20px;\n  margin: 0;\n}\n\n.rt-plan-detail__grid dt {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.rt-plan-detail__grid dd {\n  margin: 0;\n  font-size: 0.95rem;\n  color: var(--text-primary);\n  word-break: break-word;\n}\n\n.rt-plan-detail__span {\n  grid-column: 1 / -1;\n}\n\n.rt-plan-detail__danger {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n}\n\n/* Metric cards that embed badges */\n.rt-plan-detail .rt-metric-card__value {\n  display: flex;\n  align-items: center;\n  min-height: 1.6em;\n}\n\n/* Run plan modal */\n.rt-run-plan-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n  z-index: 13000;\n}\n\n.rt-run-plan-panel {\n  width: 100%;\n  max-width: 28rem;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--modal-background, var(--surface));\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--modal-shadow, var(--shadow-lg));\n}\n\n.rt-run-plan-header {\n  flex-shrink: 0;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(to right, var(--primary), var(--primary-hover));\n  color: #fff;\n}\n\n.rt-run-plan-header h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.rt-run-plan-header p {\n  margin: 0.25rem 0 0;\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.rt-run-plan-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.rt-run-plan-project {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border: 1px solid color-mix(in srgb, var(--primary) 30%, var(--border));\n  background: var(--primary-muted);\n}\n\n.rt-run-plan-project p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n.rt-run-plan-label {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.rt-run-plan-field label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rt-required {\n  color: var(--danger, #ef4444);\n}\n\n.rt-run-plan-hint {\n  margin: 0.4rem 0 0;\n  font-size: 0.75rem;\n  color: var(--primary);\n  word-break: break-all;\n}\n\n.rt-run-plan-mode {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.9rem 1rem;\n  margin-top: 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface-raised, var(--surface));\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.rt-run-plan-mode--active {\n  border-color: var(--primary);\n  background: var(--primary-muted);\n}\n\n.rt-run-plan-mode--disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.rt-run-plan-mode__title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rt-run-plan-mode__desc {\n  margin: 0.2rem 0 0;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.rt-run-plan-soon {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rt-run-plan-mode--disabled:hover .rt-run-plan-soon {\n  opacity: 1;\n}\n\n.rt-run-plan-error {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  border: 1px solid color-mix(in srgb, var(--danger) 35%, var(--border));\n  background: var(--danger-muted);\n  color: var(--danger);\n  font-size: 0.875rem;\n}\n\n.rt-run-plan-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-top: 1px solid var(--border);\n  background: var(--bg-tertiary, var(--surface));\n}\n\n[data-theme=\"light\"] .rt-run-plan-footer {\n  background: var(--modal-background, #fff);\n}\n\n.rt-run-plan-info {\n  padding: 0.75rem 1.25rem;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  border-top: 1px solid var(--border);\n  background: var(--primary-muted);\n}\n\n/* Edit plan modal chrome */\n.rt-plan-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n}\n\n.rt-plan-modal-panel {\n  width: min(640px, 92vw);\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--modal-background, var(--surface));\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--modal-shadow, var(--shadow-lg));\n}\n\n.rt-plan-modal-panel--sm {\n  max-width: 28rem;\n  padding: 1.25rem;\n  display: block;\n}\n\n.rt-plan-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(to right, var(--primary), var(--primary-hover));\n  color: #fff;\n}\n\n.rt-plan-modal-header h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #fff;\n}\n\n.rt-plan-modal-close {\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 1.5rem;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.rt-plan-modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 1.25rem;\n  background: var(--modal-background, var(--surface));\n  color: var(--text-primary);\n}\n\n.rt-plan-modal-footer {\n  padding: 1rem 1.25rem;\n  border-top: 1px solid var(--border);\n  background: var(--bg-tertiary, var(--surface));\n}\n\n[data-theme=\"light\"] .rt-plan-modal-footer {\n  background: var(--modal-background, #fff);\n}\n\n.rt-plan-page-body {\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  color: var(--text-primary);\n}\n\n.rt-plan-confirm-title {\n  margin: 0 0 0.5rem;\n  color: var(--text-primary);\n}\n\n.rt-plan-confirm-body {\n  margin: 0 0 1.25rem;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.rt-plan-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
